import { z } from 'zod';

export const ProviderIdSchema = z.enum(['anthropic', 'openai', 'google']);
export type ProviderId = z.infer<typeof ProviderIdSchema>;

export const LlmCatalogModelSchema = z.object({
  id: z.string(),
  label: z.string(),
});
export type LlmCatalogModel = z.infer<typeof LlmCatalogModelSchema>;

export const LlmCatalogProviderSchema = z.object({
  id: ProviderIdSchema,
  label: z.string(),
  available: z.boolean(),
  models: z.array(LlmCatalogModelSchema),
});
export type LlmCatalogProvider = z.infer<typeof LlmCatalogProviderSchema>;

export const LlmCatalogResponseSchema = z.object({
  providers: z.array(LlmCatalogProviderSchema),
});
export type LlmCatalogResponse = z.infer<typeof LlmCatalogResponseSchema>;

export const LlmKeyRowSchema = z.object({
  id: z.string(),
  label: z.string(),
  provider: ProviderIdSchema,
  model: z.string(),
  fingerprint: z.string(),
  isDefault: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type LlmKeyRow = z.infer<typeof LlmKeyRowSchema>;

export const LlmKeyListResponseSchema = z.object({
  items: z.array(LlmKeyRowSchema),
});
export type LlmKeyListResponse = z.infer<typeof LlmKeyListResponseSchema>;

export const LlmKeyTestResponseSchema = z.union([
  z.object({ ok: z.literal(true), latencyMs: z.number() }),
  z.object({
    ok: z.literal(false),
    error: z.object({ code: z.string(), message: z.string() }),
  }),
]);
export type LlmKeyTestResponse = z.infer<typeof LlmKeyTestResponseSchema>;

export interface CreateLlmKeyBody {
  label: string;
  provider: ProviderId;
  model: string;
  apiKey: string;
  makeDefault?: boolean;
}

export interface UpdateLlmKeyBody {
  label?: string;
  model?: string;
  apiKey?: string;
  makeDefault?: boolean;
}
